import React from 'react'
// import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './notFound.css'

const NotFound = () => {

    // const navigate = useNavigate();
    // const { extra } = useParams(); // Access the extra part of the URL

    // React.useEffect(() => {
    //     if (extra === 'homee') {
    //     navigate('/home');
    //     }
    // }, [extra, navigate]);

    // const location = useLocation();
    // const path = location.pathname;

    const location = useLocation();
    let path = location.pathname;

    // Find the index of the first '/'
    const firstSlashIndex = path.indexOf('/');

    // Remove everything before the first '/'
    if (firstSlashIndex !== -1) {
        path = path.substring(firstSlashIndex + 1);
    }

    
    return (
        <div className="container">
          <div className="row">
            <div className="content">
              <h1 className="title">404</h1>
              <p className="subtitle"> <strong>{path}</strong> page could not be found.</p>
            </div>
            <div className="goHome">
                <a href="/" className="goHome__btn">Go Home</a>
            </div>
          </div>
        </div>
      );
}

export default NotFound